import axios from "axios";

export default {
  async find() {
    return axios.get(`/settings`);
  },
  async update(formData) {
    return axios.put(`/settings/${formData.id}`, {settings: formData});
  },
};
